const excel =
  '<svg width="15" height="17" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.25 3.16675H15V13.8334H11.25V3.16675Z" fill="#8F8B8F"/><path d="M0 13.8333L10.5 16.5V0.5L0 3.16667V13.8333ZM2.62493 4.94444H4.29368L5.23118 6.91778L6.20622 4.94444H7.83743L6.13115 7.77108L8.00615 11.0955H6.3374L5.23118 8.74879L4.14368 11.0955H2.51247L4.33122 7.82441L2.62493 4.94444Z" fill="#8F8B8F"/></svg>';

export default excel;
